import { type Dispatch, createContext, useContext, type SetStateAction } from 'react'
import { type Country } from '../../../types/dataModel/platformSdk'
import { type LoginStep } from './types'

export interface LoginContextProps {
  phone: string
  setPhone: Dispatch<SetStateAction<string>>
  phoneError: string
  setPhoneError: Dispatch<SetStateAction<string>>
  step: LoginStep
  setStep: (step: LoginStep) => void
  email?: string
  setEmail: Dispatch<SetStateAction<string>>
  validatePhone: () => void
  countryCode?: Country['countryIsoCode']
  setCountryCode: Dispatch<SetStateAction<Country['countryIsoCode'] | undefined>>
  backStep: () => void
  /** 由驗證碼頁寫入，Email 輸入頁就地標紅並鎖住送出 */
  isEmailDomainRejected: boolean
  setIsEmailDomainRejected: Dispatch<SetStateAction<boolean>>
}

export const LoginContext = createContext<LoginContextProps | null>(null)

export function useContextLogin() {
  const loginContext = useContext(LoginContext)

  if (!loginContext) throw new Error('LoginContext has to be used within <LoginContext.Provider>')

  return loginContext
}
